<template>
    <v-tab-item :value="ONLINE.value">
        <div class="page-section-wrap">
            <section class="page-section">
                <div>
                    <v-row>
                        <v-col cols="12" lg="3">
                            <h2 class="tit">온라인 경매</h2>
                        </v-col>
                        <v-col cols="12" lg="9">
                            <div>
                                <div class="mb-10">
                                    <h4 class="tit tit--xs">경매 참여</h4>
                                </div>
                                <ul class="letter-list">
                                    <li><em>-</em><span>'응찰' 혹은 '예약응찰' 버튼을 클릭해 응찰 페이지로 이동하여 경매에 참여할 수 있습니다.</span></li>
                                    <li><em>-</em><span>원하시는 작품의 현재가를 확인 후 최고 응찰가를 선택하여 응찰할 수 있습니다.</span></li>
                                    <li><em>-</em><span>실시간으로 응찰하거나 미리 최고 응찰가를 입력해두시면 해당 작품의 다른 응찰에 대응하여 사전에 입력한 최고 응찰가까지 <br class="d-none d-md-block"/>자동으로 응찰이 이뤄집니다.</span></li>
                                </ul>
                            </div>
                            <div class="mt-18 mt-md-30">
                                <div class="mb-10">
                                    <h4 class="tit tit--xs">마감 시간</h4>
                                </div>
                                <ul class="letter-list">
                                    <li><em>-</em><span>프리뷰 전시 기간 동안 홈페이지를 통해 응찰 가능하며, 경매 마감 시간부터 lot 번호 순차적으로 마감됩니다.</span></li>
                                    <li><em>-</em><span>각 작품마다 마감시간이 다르며, LOT순 1분 간격 1점씩 마감됩니다.</span></li>
                                    <li><em>-</em><span>작품 마감 30초 전에 응찰이 들어왔을 경우, 해당작품 마감이 30초 연장됩니다.</span></li>
                                    <li><em>-</em><span>온라인 경매 회차에 따라 위 마감 시간이 다를 수 있습니다.</span></li>
                                    <li><em>-</em><span>한번 응찰된 작품은 응찰을 취소 할 수 없습니다. 신중한 선택 부탁 드립니다.</span></li>
                                    <li><em>-</em><span>경매 마감 시간부터 5분 간격으로 10점씩 마감되며, 경매 마감 시간 30초 전에 새로운 응찰이 있을 경우 마감시간이 자동으로 <br class="d-none d-md-block"/>30초 연장됩니다.</span></li>
                                </ul>
                            </div>
                            <div class="mt-18 mt-md-30">
                                <div class="mb-10">
                                    <h4 class="tit tit--xs">수동응찰 · 자동응찰</h4>
                                </div>
                                <div>
                                    <v-row no-gutters>
                                        <v-col cols="12" md="6">
                                            <v-card tile outlined class="h-100">
                                                <div class="pa-16 px-md-30 py-md-20">
                                                    <v-row>
                                                        <v-col cols="auto">
                                                            <v-img contain width="40" height="40" src="/images/sub/how-to/how-to-bid-online-icon.png"></v-img>
                                                        </v-col>
                                                        <v-col>
                                                            <div class="page-text">
                                                                <p class="primary--text">1회응찰 / Bid</p>
                                                                <p>주어진 금액에 따라 1회씩 수동응찰</p>
                                                            </div>
                                                        </v-col>
                                                    </v-row>
                                                </div>
                                            </v-card>
                                        </v-col>
                                        <v-col cols="12" md="6" class="mt-n1 mt-md-0 ml-md-n1">
                                            <v-card tile outlined class="h-100">
                                                <div class="pa-16 px-md-30 py-md-20">
                                                    <v-row>
                                                        <v-col cols="auto">
                                                            <v-img contain width="42" height="42" src="/images/sub/how-to/how-to-bid-online-icon2.png"></v-img>
                                                        </v-col>
                                                        <v-col>
                                                            <div class="page-text">
                                                                <p class="primary--text">자동응찰 / Automatic Bid</p>
                                                                <p>작품의 한도액을 미리 설정해 자동으로 응찰</p>
                                                            </div>
                                                            <p class="page-text font-size-14 line-height-13 mt-4">* 자동응찰의 경우 상대응찰자가 없으면 최소 금액으로 낙찰됩니다.</p>
                                                        </v-col>
                                                    </v-row>
                                                </div>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                </div>
                            </div>
                            <div class="mt-18 mt-md-30">
                                <div class="mb-10">
                                    <h4 class="tit tit--xs">우선 순위</h4>
                                </div>
                                <ul class="letter-list">
                                    <li><em>-</em><span>경매 낙찰은 시작 후 최고가를 제시한 응찰자에게 경매작품이 낙찰되며, 자동응찰 > 수동 응찰 순으로 우선적으로 낙찰 기회가 주어집니다.</span></li>
                                    <li><em>-</em><span>동일한 금액의 응찰이 발생할 경우 서버시각에 따라 먼저 응찰금액을 입력하신 분에게 우선 순위가 주어집니다.</span></li>
                                    <li><em>-</em><span>응찰 시 응찰 단위 기준으로 금액이 상승합니다.</span></li>
                                </ul>
                            </div>
                            <div class="mt-18 mt-md-30">
                                <div class="mb-10">
                                    <h4 class="tit tit--xs">호가단위 자동 변경기준</h4>
                                </div>
                                <p class="page-text">다음과 같이 온라인 경매 응찰 금액대별 호가단위가 자동 변경됩니다.</p>
                                <div class="mt-10 mt-md-14">
                                    <div class="table-scroll">
                                        <div class="table-scroll__inner">
                                            <v-simple-table class="v-simple-table v-data-table--none-active-bg v-data-table--default v-data-table--none-border-left text-center primary--text" style="min-width:768px;">
                                                <tbody>
                                                    <tr>
                                                        <th style="width:10%">이상</th>
                                                        <td>~</td>
                                                        <td>100만원</td>
                                                        <td>300만원</td>
                                                        <td>500만원</td>
                                                        <td>1,000만원</td>
                                                        <td>3,000만원</td>
                                                        <td>5,000만원</td>
                                                        <td>1억원</td>
                                                        <td>2억원</td>
                                                    </tr>
                                                    <tr>
                                                        <th>미만</th>
                                                        <td>100만원</td>
                                                        <td>300만원</td>
                                                        <td>500만원</td>
                                                        <td>1,000만원</td>
                                                        <td>3,000만원</td>
                                                        <td>5,000만원</td>
                                                        <td>1억원</td>
                                                        <td>2억원</td>
                                                        <td>~</td>
                                                    </tr>
                                                    <tr>
                                                        <th>호가</th>
                                                        <td>5만원</td>
                                                        <td>10만원</td>
                                                        <td>20만원</td>
                                                        <td>30만원</td>
                                                        <td>50만원</td>
                                                        <td>100만원</td>
                                                        <td>200만원</td>
                                                        <td>300만원</td>
                                                        <td>500만원</td>
                                                    </tr>
                                                </tbody>
                                            </v-simple-table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="mt-18 mt-md-30">
                                <div class="mb-10">
                                    <h4 class="tit tit--xs">온라인경매 예약응찰</h4>
                                </div>
                                <p class="page-text">미리 설정한 최대 응찰금액 까지 자동으로 응찰이 이루어지게 하는 방식입니다.</p>
                                <ul class="letter-list mt-6 mt-md-10">
                                    <li>
                                        <em><strong>예)</strong></em>
                                        <div>
                                            <p class="page-text">
                                                <strong>시작가 1,000,000원 (호가단위 100,000원)</strong><br/>
                                                상기 작품에 대해 2,000,000원 까지 예약응찰 할 경우 다른 응찰자가 1,100,000원 응찰 시<br/>
                                                1,200,000원이 자동응찰 되며, 이후 응찰이 더 발생할 경우 입력한 2,000,000원 까지 자동응찰됩니다.
                                            </p>
                                            <p class="page-text mt-6 mt-md-10">
                                                <strong>설정 금액 보다 낮은 가격에서 경매가 끝난다면?</strong><br/>
                                                설정해둔 최대 응찰가 2,000,000원 과는 상관없이 경합된 금액까지만 낙찰가로 결정됩니다.
                                            </p>
                                            <p class="page-text mt-6 mt-md-10">
                                                <strong>설정한 금액 보다 높게 응찰이 이어진다면?</strong><br/>
                                                예약한 최대 응찰가를 넘어섰으므로, 직접 응찰을 진행해야 경매참여가 가능합니다.
                                            </p>
                                        </div>
                                    </li>
                                </ul>
                                <ul class="letter-list mt-6 mt-md-10">
                                    <li><em>-</em><span>일반응찰과 동일금액으로 응찰된 경우 예약응찰이 우선시 됩니다.</span></li>
                                    <li><em>-</em><span>예약응찰은 경매 당일 오후 3시 까지만 응찰 가능합니다.</span></li>
                                    <li><em>-</em><span>예약응찰 역시 응찰을 취소 할 수 없습니다.신중한 선택 부탁드립니다.</span></li>
                                </ul>
                            </div>
                        </v-col>
                    </v-row>
                </div>
            </section>
        </div>
    </v-tab-item>
</template>

<script>
import { HOW_TO_BID_TABS } from "@/assets/variables";
const { ONLINE } = HOW_TO_BID_TABS;
export default {
    data() {
        return {
            ONLINE,
        };
    },
};
</script>

<style></style>
